module.exports = __webpack_public_path__ + "img/injoy.af50434e.png";